import React from "react";

function Question() {
  return (
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="-10 -10 550 550"
>
  <circle cx="256" cy="256" r="248" fill="none" stroke="currentColor" strokeWidth="30"/>

  <path 
    fill="currentColor"
    d="M256 344c-13.3 0-24 10.7-24 24s10.7 24 24 24 
       24-10.7 24-24-10.7-24-24-24zm0-264c-53 0-96 43-96 96h48c0-26.5 21.5-48 48-48s48 21.5 
       48 48-21.5 48-48 48c-13.3 0-24 10.7-24 24v40h48v-23.4c38.2-11 64-46.1 
       64-88.6 0-53-43-96-96-96z"
  />
</svg>
  );
}

export default Question;
